import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselComponent } from './carousel.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Image360ViewerComponent } from '../image-360-viewer/image-360-viewer.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatProgressSpinnerModule],
  declarations: [CarouselComponent, Image360ViewerComponent],
  exports: [CarouselComponent, MatIconModule, MatProgressSpinnerModule],
})
export class CarouselModule {}
